import { render, staticRenderFns } from "./relatorioPaisagem.vue?vue&type=template&id=2b2a392a"
import script from "./relatorioPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioPaisagem.vue?vue&type=script&lang=js"
import style0 from "./relatorioPaisagem.vue?vue&type=style&index=0&id=2b2a392a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports